var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcInventoryFill = function SvgIcInventoryFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.771 1.79c-1.649 0-3.115.46-4.176 1.468-.744.708-1.226 1.625-1.45 2.695C2.029 6.515 2.495 7 3.068 7h17.87c.572 0 1.037-.483.922-1.044-.22-1.07-.699-1.989-1.442-2.697-1.059-1.01-2.527-1.47-4.179-1.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 9.6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6.957c0 1.71-.524 3.16-1.59 4.178-1.06 1.01-2.527 1.475-4.181 1.475H7.771c-1.655 0-3.124-.474-4.183-1.5C2.524 19.677 2 18.21 2 16.481zm8.31 1.434a1 1 0 1 0-1.489 1.337c1.779 1.98 4.6 1.952 6.357 0a1 1 0 0 0-1.486-1.338c-.971 1.079-2.407 1.088-3.383.001",
    clipRule: "evenodd"
  })));
};
export default SvgIcInventoryFill;